module.exports = __webpack_public_path__ + "static/media/Travaux_white.8b5820d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/Travaux_white.svg
// module id = 1709
// module chunks = 0